import React from "react";
import { useTranslation } from "react-i18next";
import { ButtonBase } from "../../../common/components/form";

export default function PaymentMethodChosing(props) {
    const { t } = useTranslation();
    const refPanelConfirm = React.useRef(null);
    const CNPanelConfirm = ["panel-payment-method"];
    props.show && CNPanelConfirm.push("show");

    React.useEffect(() => {
        const domPanelConfirm = refPanelConfirm?.current;

        if (domPanelConfirm && !domPanelConfirm._inBody /*  domPanelConfirm.parentElement !== document.body */) {
            domPanelConfirm._inBody = true;
            const dom = domPanelConfirm.cloneNode(true);
            document.body.appendChild(dom);

            domPanelConfirm.addEventListener("pointerup", onPointerUp);

            return () => {
                const domPanelConfirm = refPanelConfirm?.current;

                if (domPanelConfirm) {
                    domPanelConfirm.removeEventListener("pointerup", onPointerUp);
                    dom.parentElement && dom.parentElement.removeChild(dom);
                }
            };
        }
    }, [refPanelConfirm]);

    function onPointerUp(event) {
        if (event.target instanceof HTMLButtonElement) {
            event.preventDefault();
            props?.actions?.[event.target?.dataset?.clickindex]?.onClick?.(event);
        }
    }

    return (
        <div ref={refPanelConfirm} className={CNPanelConfirm.join(" ")}>
            <div className="panel-payment-method-content">
                <div className="panel-payment-method-content-text">
                    <h2 className="panel-payment-method-header">{props.header}</h2>
                    <p className="panel-confirm-text">{props.text}</p>

                    {props.planToChange && (
                        <p className="panel-confirm-text">
                            {t("TotalPriceText")} {props?.planToChange?.parameters.price * 12}{" "}
                            {props?.planToChange?.parameters.currency}$
                        </p>
                    )}
                </div>

                <div className="panel-payment-method-choosing-actions">
                    {props?.actions?.map(({ onClick, text, props }, index) => (
                        <ButtonBase key={index} onClick={onClick} {...props} data-clickindex={index}>
                            {text}
                        </ButtonBase>
                    ))}
                </div>
            </div>
        </div>
    );
}
